export default __webpack_public_path__ + "static/media/pc_step_1_Hk.8a66c497.jpg";